import React, { useContext } from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { UserMention } from '../../../../../javascript/components/HighlightedMentions/UserMention';
import { TaskMention } from '../../../../../javascript/components/HighlightedMentions/TaskMention';
import {
  getUser,
  getTask,
  isTaskMention
} from '../../../../../javascript/components/HighlightedMentions/utils';
import type { User as HmUser } from '../../../../../javascript/components/HighlightedMentions/types';
import { MentionPreviewContext } from './mentionPreviewContext';
import hmStyles from '../../../../../javascript/components/HighlightedMentions/index.module.css';

const asHmUsers = (
  list: { id: number; name: string; email?: string }[] | undefined
): HmUser[] | undefined => list as HmUser[] | undefined;

export const BugherdMentionPreviewView = ({ node }: NodeViewProps) => {
  const ctx = useContext(MentionPreviewContext);
  const id = String(node.attrs.id ?? '');
  const label = String(node.attrs.label ?? id);
  const markdown = ctx?.descriptionMarkdown ?? '';
  const pointerEventsAuto: React.CSSProperties = { pointerEvents: 'auto' };

  const hasContext = !!(ctx?.projectUsers?.length || ctx?.projectMembers?.length || ctx?.mentionableTasks?.length);

  let content: React.ReactNode = `@${label}`;
  let className: string | undefined = hmStyles.mention;

  if (hasContext && ctx) {
    className = undefined;
    if (isTaskMention(markdown, id)) {
      content = (
        <TaskMention
          id={id}
          task={getTask(id, ctx.mentionableTasks ?? [])}
          setActiveTask={ctx.setActiveTask}
          description={markdown}
        />
      );
    } else {
      const allUsers = asHmUsers(ctx.allUsers);
      const projectUsers = asHmUsers(ctx.projectUsers);
      content = (
        <UserMention
          id={id}
          description={markdown}
          user={getUser(id, allUsers ?? [])}
          projectUser={getUser(id, projectUsers ?? [])}
          isComment={!!ctx.isComment}
          isPrivate={!!ctx.isPrivate}
        />
      );
    }
  }

  return (
    <NodeViewWrapper
      as="span"
      data-type="mention"
      contentEditable={false}
      style={pointerEventsAuto}
      className={className}
    >
      {content}
    </NodeViewWrapper>
  );
};
